// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.old-webviewer{height:calc(100vh - 240px)}`, "",{"version":3,"sources":["webpack://./src/components/old_pdf_viewer/index.scss"],"names":[],"mappings":"AAAA,eACI,0BAAA","sourcesContent":[".old-webviewer {\n    height: calc(100vh - 240px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
